import { AppRouterInstance, NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime"
import { useParams } from "next/navigation"

const useLocaleRouter = (router: AppRouterInstance) => {
  const { locale } = useParams()

  return {
    push: (href: string, options?: NavigateOptions) => {
      router.push(`/${locale}${href}`, options)
    },
    replace: (href: string, options?: NavigateOptions) => {
      router.replace(`/${locale}${href}`, options)
    },
  }
}



export default useLocaleRouter